module.exports = __webpack_public_path__ + "static/img/SoftwareSupportDetail_avatar.c5079991.png";